import { VerifyComponent } from './verify/verify.component';
import { InvitationPageComponent } from './invitation-page/invitation-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreComponent } from './core.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'prefix' },
  {path: 'login', component: LoginComponent},
  {path: 'verify', component: VerifyComponent},
  {path: 'reset', component: VerifyComponent},

  {path: 'invitation', component: InvitationPageComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
